<template>
  <div>
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              Month
            </th>
            <th class="text-left">
              Week
            </th>
            <th class="text-left">
                Assign Date
              </th>
            <th class="text-left">
              Work Sheet
            </th>
            <th v-if="user.user_role=='Student'" class="text-left">
             Tutor Name
            </th>
            <th v-if="user.user_role=='Tutor'">
              Student Name
            </th>
            <th class="text-left">
              Subject
            </th>
            <th class="text-left">
              Class
            </th>
            <th class="text-left">
              Code
            </th>

            <!-- <th class="text-left">
              Version
            </th> -->
          </tr>
        </thead>
        <tbody>
          <template v-if="items.length > 0">
            <template v-for="(item, ind) in items">
              <tr v-for="(data, index) in item" :key="index">
                
                <td> 
                  <p v-for="sheet in data"> 
                    {{ sheet.month }} 
                  </p> 
                </td>
                <td>
                      <p v-for="sheet in data" :key="sheet">
                        {{ (sheet.week) ? sheet.week : 'Not Found' }}
                      </p>
                  </td>
               
                <td>
                      <p v-for="(sheet, code_index) in data" :key="sheet">
                        <!-- {{ (code_index == 0 ) ? sheet.work_sheet_code : '' }} -->
                        {{ sheet.created }}
                      </p>
                  </td>
                <td>
                  <template v-for="(sheet ,work_index) in data">
                    <!-- v-if="!sheet.student_fname ||sheet.student_fname =='' " -->
                    <p v-if="!sheet.student_fname || sheet.student_fname ==''">
                        <a
                          class="profile-link"
                          active-class="active"
                          :exact="true"
                          :href="`https://view.officeapps.live.com/op/view.aspx?src=${getBaseURL}/storage/${sheet.work_sheet}`"
                          target="_blank">
                          <p class="table-tutor-name">view</p>
                        </a>
                    </p>
                    <p v-else :key="work_index">
                        <a
                          class="profile-link"
                          active-class="active"
                          :exact="true"
                          @click="openDialog(sheet)"
                        >
                          <p class="table-tutor-name" >view</p>
                        </a>
                    </p>
                  </template>
                </td>
                <td>
                  <p v-for="sheet in data" :key="sheet"> {{ (!sheet.student_fname) ? sheet.tutor_fname : sheet.student_fname  }}</p>
                </td>
                <td>
                    <p v-for="sheet in data" :key="sheet">
                      {{ (sheet.subject) ? sheet.subject : 'Not Found' }}
                    </p>
                </td>
                <td>
                    <p v-for="sheet in data" :key="sheet">
                      {{ (  sheet.class_code) ? sheet.class_code : 'Not Found'  }}
                    </p>
                </td>
              <td>
                      <p v-for="(sheet, code_index) in data" :key="sheet">
                        <!-- {{ (code_index == 0 ) ? sheet.work_sheet_code : '' }} -->
                        {{ sheet.work_sheet_code }}
                      </p>
                  </td>

                <!-- <td>
                    <p v-for="sheet in data" :key="sheet">
                      {{ (sheet.version) ? sheet.version : 'Not Found' }}
                    </p>
                </td> -->
              </tr>
            </template>
          </template>
          <template v-else>
            <tr class="text-center">
              <td colspan="7">No record found</td>
            </tr>
          </template>
        </tbody>
       
      </template>
      
    </v-simple-table>

    <v-dialog v-model="dialog" persistent max-width="600px"> </v-dialog>

    <v-overlay :value="overlay" style="z-index: 99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <delete-dialog
      @success="deleteGroup"
      :confirm-loading="deleteConfirmLoading"
      @closeDialog="cancelDelete"
      :dialog="delete_dialog"
      title="Group"
    ></delete-dialog>
 
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
    
       max-width="900"
        hide-overlay
     
      scrollable
    >
    
      <v-card>
        <v-card-title class=" justify-center">
          <span class="headline justify-center"> {{student_name}}</span>
         
       
        </v-card-title>
        <v-card-text>
       
   
        <div style="width: 100%; height: 1000px position: relative;">

        <iframe :src="this.src"
              frameborder="0" scrolling="no" seamless="" style="width: 100%; height: 100vh">
              <p>Your browser does not support iframes.</p>
        </iframe>
        <div style="width: 100%; height: 180px; position: absolute; background-color:blue; opacity: 0; right: 0px; top: 0px;"></div>
        </div>
        </v-card-text>
        <v-card-actions >
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false, src=null"
          >
            Close
          </v-btn>
        
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

  </div>
</template>

<script>
// import DiscountDialog from "./DiscountDialog";
// import TutorAssignmentForm from "./TutorAssignmentForm";
import DataTableMixin from "../../../mixins/dataTable";
import Form from "../../../utils/form";
import DeleteDialog from "../../Dialogs/DeleteDialog";
import DeleteRow from "../../../mixins/deleteRow";
import moment from "moment";
import _ from "lodash";
export default {
  name: "WorkSheet",
  components: {
    DeleteDialog,
  },
  mixins: [DataTableMixin, DeleteRow],
  data() {
    return {
      search: "",
      overlay: false,
      errors: {},
      url: process.env.VUE_APP_BASE_URL,
      dialog: false,
      src:'',
      student_name:"",
      currentRow: 0,
      loading: true,
      page: 1,
      pageCount: 3,
      itemsPerPage: 10,
      user:"",
    };
  },
  computed: {
    getBaseURL(url) {
     return window.baseURL;
    },
  },
  watch: {
    search: _.debounce(function(val) {
      axios
        .post(apiRoutes.WorkSheet.assignedWorkSheetOfStudent, { search: val })
        .then((response) => {
          // this.formalizeTable(response.data);
          this.items = [response.data.response];
          this.loading = false;
        });
    }, 1500),
  },
  methods: {
    openDialog(item){
      this.dialog=true;
      // &output=[pdf]
      //  :href="`https://view.officeapps.live.com/op/view.aspx?src= http://prelive.qslearning.co.uk/public/storage/workSheet/-FlzuoD1WUKtgAg2uH63hVGmE9gj7ndGp7Q6Inrru.docx&embedded=true&output=[pdf]`"

      //  :href="`https://view.officeapps.live.com/op/view.aspx?src=${getBaseURL}/storage/${sheet.work_sheet}`"
      // this.src = 'https://docs.google.com/viewerng/viewer?url=http://prelive.qslearning.co.uk/public/storage/workSheet/-iW2jD9iXpSTesiF7c0lWvF3Xcjr00ahq5xm7eIhp.docx&embedded=true';
      this.src = `https://view.officeapps.live.com/op/view.aspx?src=${this.url}/storage/${item.tutor_work_sheet}&embedded=true`;
      // this.src = `https://view.officeapps.live.com/op/view.aspx?src= http://prelive.qslearning.co.uk/public/storage/workSheet/-FlzuoD1WUKtgAg2uH63hVGmE9gj7ndGp7Q6Inrru.docx&embedded=true`;
    //  window.getElementById('#AppHeaderPanel').style.dispaly = 'none';
      this.student_name= item.student_fname
    },
   
    myFunction: function(item) {
    var myWindow =  window.open( 
        `https://docs.google.com/viewerng/viewer?url=${this.url}/storage/${item.work_sheet}`, '_new','noopener');
 
     myWindow.focus(); 
    this.getItems();   
    },
    month(month) {
      let data = [];
      data["September"] = 1;
      data["October"] = 2;
      data["November"] = 3;
      data["December"] = 4;
      data["January"] = 5;
      data["February"] = 6;
      data["March"] = 7;
      data["April"] = 8;
      data["May"] = 9;
      data["June"] = 10;
      data["July"] = 11;
      data["August"] = 12;

      return data[month];
    },
    convert(date) {
      return moment(date).format("MMMM");
    },
    deleteGroup() {
      // console.log(this.current_row);
      axios
        .get("/joined/students/remove/" + this.current_row.std_id)
        .then((response) => {
          // this.getItems()
          this.deleteConfirmLoading = false;
          this.delete_dialog = false;
          this.getItems();
        })
        .catch((error) => {
          this.deleteConfirmLoading = false;
          this.delete_dialog = false;
          // Toast.fire({
          //     icon: 'error',
          //     title: 'Cannot Deleted Linked Groups!',
          // })
        });
    },
    cancelDelete() {
      this.deleteConfirmLoading = false;
      this.delete_dialog = false;
    },

    showDialog(item) {
      console.log(item);
      this.dialog = true;
      axios.get("classes").then((response) => {
        // this.formalizeTable(response.data);
        // this.loading = false;
        // console.log(response);
        this.classes = response.data.response;
        this.data.student_id = item.std_id;
        this.data.joining_date = item.std_joining_date;
        this.data.ending_date = item.std_leaving_date;
        this.data.date_of_birth = item.std_dob;
        this.data.number_of_hours = item.std_no_of_hours;
        this.data.selected_class = parseInt(item.class_id);
      });
    },
    download(item) {
      axios
        .post(apiRoutes.WorkSheet.downloadworkSheet, {
          file: item.work_sheet,
        })
        .then((response) => {
          this.loading = false;
        });
    },
    getItems() {
      axios
        .post(apiRoutes.WorkSheet.assignedWorkSheetOfStudent, {
          'search': this.search,
        })
        .then((response) => {
          // this.formalizeTable(response.data);
          this.items = [response.data.response];
          for (let el of this.items ) {
            console.log(el);
            if (el.length == 0) {
                 this.items =[]
            }
            break;
          }
          this.loading = false;
        });
    },
  },
  mounted() {
    this.getItems();
    this.user = JSON.parse(localStorage.getItem("user"));
    console.log(this.user);
  },
};
</script>

<style scoped>
#AppHeaderPanel{
  display: none !important;
}
.AppHeaderPanel{
    display: none !important;
}
.footer {
   position: fixed;
   left: 0;
   right:0;
   bottom: 0;
   width: 100%;
    /* max-width: 500px; */
 
}
.ndfHFb-c4YZDc-Wrql6b{
  display: none !important;
}
div[aria-label="Pop-out"] {
    display: none;
}

</style>
